import styled from "styled-components";

export const WhiteBtn = styled.button`
  border-radius: 14px;
  box-shadow: 0 1px 3px 0 rgba(53, 58, 80, 0.1);
  width: 40%;
  height: 42px;
  background-color: #ffffff;
  padding: 6px 7px 5px;
  font-size: 0.833em;`;
